import axiosInstance from '../utils/axiosInstance';

// SMT Endpoint to get tickets
export const fetchSmtTicketsForMyself = async (NTID) => {
  const url = `${process.env.REACT_APP_BE_URL}/api/v1/smt/tickets/details`;
  try {
    const dataToSend = {
      corporate_id: NTID,
      start_record: 0,
      max_limit: 500
    }; // Your data to be sent in the POST request
    const response = await axiosInstance.post(url, dataToSend)
    //console.log('TF SMT myself: ', {response});
    if (response.status === 200) {
      if (response.data.data && response.data.data.length === 0) {
        // User does not have SMT
        return response.data.data; //this should be an empty array.
      } else {
        // return smt tickets for the user
        return response.data;
      }
    } else {
      // TODO: error in smt call implement alert here!
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch Smt Tickets For Myself:', error);
    return [];
  }
};

export const downloadAttachment = async (sysId) => {
  const url = `/api/v1/snow/incidents/attachments/${sysId}`;

  try {
    const response = await axiosInstance.get(url);
    const responseBody = response.data;

    // We now check for the deep path that you discovered in your successful log.
    if (responseBody && responseBody.data && Array.isArray(responseBody.data) && responseBody.data.length > 0 && responseBody.data[0].result) {

      // We return the deeply nested 'result' object.
      // This is the object that your component's handleDownloadAttachment function needs.
      return responseBody.data[0].result;

    } else {
      console.error('UI Error: Invalid response structure. Expected "response.data.data[0].result", but did not find it:', responseBody);
      return null;
    }

  } catch (error) {
    console.error(`UI Error: The API call to ${url} failed:`, error);
    if (error.response) {
      console.error('Axios error details:', error.response.data);
    }
    return null;
  }
};

export const uploadAttachment = async (ticketNumber, sysId, fileName, base64Data) => {
  const url = `/api/v1/snow/incidents/upload/attachments`;

  // 1. Dynamically calculate the correct table name based on the ticket prefix
  const tableName = ticketNumber.startsWith('UR') ? 'universal_request' : 'incident';

  // 2. Build the payload using the 32-character sys_id
  const body = {
    table_name: tableName,
    table_sys_id: sysId, // This must be the 32-character string!
    file_name: fileName,
    base64_encodedcontent: base64Data
  };

  try {
    const response = await axiosInstance.post(url, body);
    const responseBody = response.data;

    if (responseBody && response.data.isSuccessful) {
      return responseBody.isSuccessful;
    } else {
      console.error('UI Error: Upload API call succeeded but returned a non-success status or invalid structure:', response.data);
      return null;
    }
  } catch (error) {
    console.error(`UI Error: Failed to upload file ${fileName}:`, error);
    if (error.response) {
      console.error('Axios error details:', error.response.data); // !IMPORTANT- Remove that log, as it returns to much data.
    }
    return null;
  }
};

export const addWorkNote = async (incidentNumber, noteText) => {
  const url = `/api/v1/snow/incidents/update`;
  const body = {
    number: incidentNumber,
    work_notes: noteText
  };

  try {
    const response = await axiosInstance.patch(url, body);
    const responseBody = response.data;

    // Check for the success structure
    if (responseBody && response.data.isSuccessful && responseBody.message === `Incident ${incidentNumber} updated successfully.`) {
      return responseBody.isSuccessful;
    } else {
      console.error('UI Error: Add work note API call returned a non-success status:', response?.data?.message);
      return null;
    }
  } catch (error) {
    console.error(`UI Error: Failed to add work note:`, error.message);
    return null;
  }
};

export const addComment = async (incidentNumber, commentText) => {
  const url = `/api/v1/snow/incidents/update`;
  const body = {
    number: incidentNumber,
    comments: commentText
  };

  try {
    const response = await axiosInstance.patch(url, body);
    const responseBody = response.data;

    if (responseBody && response.data.isSuccessful && responseBody.message.includes(incidentNumber)) {
      return responseBody.isSuccessful;
    } else {
      console.error('UI Error: Add comment API call returned a non-success status:', response?.data?.message);
      return null;
    }
  } catch (error) {
    console.error(`UI Error: Failed to add comment:`, error.message);
    return null;
  }
};

export const getITSMDIncidents = async (NTID, userSysId) => {
  const url = `/api/v1/snow/incidents/${NTID}${userSysId ? `?sys_id=${userSysId}` : ''}`;

  try {
    const response = await axiosInstance.get(url);
    const responseBody = response.data;
    const tickets = responseBody.data;

    if (responseBody.isSuccessful && Array.isArray(tickets)) {
      return tickets;
    } else {
      console.error('API call was successful but data is not in the expected format:', responseBody);
      return [];
    }
  } catch (error) {
    console.error('Error fetching data from /api/v1/snow/incidents:', error);
    if (error.response) {
      console.error('Axios error details:', error.response.data);
    }
    return [];
  }
};

export const getOthersITSMDIncidents = async (NTID, userSysId) => {
  const url = `/api/v1/snow/incidents/forOthers/${NTID}${userSysId ? `?sys_id=${userSysId}` : ''}`;

  try {
    const response = await axiosInstance.get(url);
    const responseBody = response.data;
    const tickets = responseBody.data;

    if (responseBody.isSuccessful && Array.isArray(tickets)) {
      return tickets;
    } else {
      console.error('API call was successful but data is not in the expected format:', responseBody);
      return [];
    }
  } catch (error) {
    console.error('Error fetching data from /api/v1/snow/incidents:', error);
    if (error.response) {
      console.error('Axios error details:', error.response.data);
    }
    return [];
  }
};

export const getITSMDIncidentsDetails = async (incidentNumber) => {
  const url = `/api/v1/snow/incidents/details/${incidentNumber}`;
  try {
    // const response = await axios.get(url);
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data;
      } else {
        console.log('Error with SN call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetching incident tickets details:', error);
    return [];
  }
}

export const getITSMDIncidentsDetailsForSapUsers = async (incidentNumber) => {
  const url = `/api/v1/snow/incidents/sap/details/${incidentNumber}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response?.data?.data;
      } else {
        console.log('Error with SN call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetching incident tickets details for sap key user search:', error);
    return [];
  }
}

export const fetchSmtTicketsForOthers = async (NTID) => {
  const url = `/api/v1/smt/tickets/details`;
  try {
    const dataToSend = {
      direct_contact_corporate_id: NTID,
      start_record: 0,
      max_limit: 200
    }; // Your data to be sent in the POST request

    const response = await axiosInstance.post(url, dataToSend);
    //console.log('TF smt others: ', {response});
    if (response.status === 200) {
      if (response.data.data && response.data.data.length === 0) {
        // User does not have SMT
        return response.data.data; //this should be an empty array.
      } else {
        // return smts for the user
        return response.data;
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch Smt Tickets ForOthers:', error);
    return [];
  }
};

export const fetchSNTicketsForMyself = async (NTID) => {
  const url = `/api/v1/snow/tickets/mySelf/${NTID}`;
  const ctpFilter = (tickets) => {
    //SNOW-1912: Filter elements with the cat_item_name "Critical ticket via RedButton page - TOM OPS"
    return tickets.filter(
      (ticket) =>
        ticket.items[0].cat_item_name !==
        'Critical ticket via RedButton page - TOM OPS'
    );
  };

  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        const myTickets = ctpFilter(response.data.data[0].response);
        return myTickets;
      } else {
        console.log('Error with SN call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch SN Tickets For Myself:', error);
    return [];
  }
};

export const fetchSNTicketsForOthers = async (NTID) => {
  const url = `/api/v1/snow/tickets/forOthers/${NTID}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data.data[0].response;
      } else {
        console.log('Error with SN call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch SN Tickets For Others:', error);
    return [];
  }
};

export const getServiceOfferingID = async (service) => {
  const url = `/api/v1/snow/feedback/valuemation/${service}`
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      return response.data
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch Offerinf ID:', error);
    return [];
  }
}

export const fetchCPSCOpenTicketsForMyself = async (NTID, codeLanguage) => {
  const url = `/api/v1/cpsc/tickets/mySelf/open/${NTID}?lang=${codeLanguage}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      return response.data.data;
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch CPSC Open Tickets For Myself:', error);
    return [];
  }
};

export const fetchCPSCClosedTicketsForMyself = async (NTID, codeLanguage) => {
  const url = `/api/v1/cpsc/tickets/mySelf/closed/${NTID}?lang=${codeLanguage}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data.data;
      } else {
        console.log('Error with CPSC call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch CPSC Closed Tickets For Myself:', error);
    return [];
  }
};

export const fetchCPSCOpenTicketsForOthers = async (NTID, codeLanguage) => {
  const url = `/api/v1/cpsc/tickets/forOthers/open/${NTID}?lang=${codeLanguage}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data.data;
      } else {
        console.log('Error with CPSC call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch CPSC Open Tickets ForOthers:', error);
    return [];
  }
};

export const fetchCPSCClosedTicketsForOthers = async (NTID, codeLanguage) => {
  const url = `/api/v1/cpsc/tickets/forOthers/closed/${NTID}?lang=${codeLanguage}`;
  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data.data;
      } else {
        console.log('Error with CPSC call, message: ', response.data.message);
        return [];
      }
    } else {
      console.log('Axios error call with status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetch CPSC Closed Tickets For Others:', error);
    return [];
  }
};

export const fetchSmtGetTicketDetailsById = async (
  incidentID,
  limit = null
) => {
  const url = `/api/v1/smt/tickets/details/id`;
  let smtTicket = {};

  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    Connection: 'keep-alive',
    Accept: '*/*'
  };

  try {
    const dataPayload = {
      incident_number: incidentID,
      start_record: 0,
      max_limit: limit ? limit : 5
    };

    const response = await axiosInstance.post(url, dataPayload, headers);

    if (response.status === 200) {
      if (response.data) {
        smtTicket =
          response.data['soapenv:Envelope']['soapenv:Body'][0]
            .HelpDesk_Query_ServiceResponse &&
          response.data['soapenv:Envelope']['soapenv:Body'][0]
            .HelpDesk_Query_ServiceResponse;
        return smtTicket;
      }
    } else return smtTicket;
  } catch (error) {
    console.error('Error:', error);
  }
};

export const getSapKeyUser = async (NTID) => {
  const url = `/api/v1/smt/sapkeyuser/status/${NTID}`;
  try {
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
};

/**
 * Create an ITSM.D (ServiceNow) incident.
 * POST /api/v1/snow/incidents/create
 *
 * Sends a minimal raw payload. The backend handles:
 * - Template injection
 * - Field mapping (impact, category, contact_type)
 * - assignment_group routing
 *
 * @param {Object} payload - Raw incident payload from mapToITSMDIncident
 * @returns {Object} { number, sys_id, status, message } on success
 * @throws {Error} on failure
 */
export const createIncident = async (payload) => {
  const url = `/api/v1/snow/incidents/create`;

  try {
    const response = await axiosInstance.post(url, payload);

    // Validate the response structure
    const result = response?.data?.data?.[0];
    if (!result || !result.status) {
      console.error('Invalid response structure:', response?.data);
      throw new Error('Unexpected response structure from the API.');
    }

    // Check if the ticket creation was successful
    if (result.status === 'success') {
      return {
        number: result.ticket_number,
        sys_id: result.sys_id,
        status: result.status,
        message: result.message,
      };
    } else {
      const errorMsg = result?.message || response?.data?.message || 'Incident creation failed';
      throw new Error(errorMsg);
    }
  } catch (error) {
    console.error('Error creating ITSM.D incident:', error);
    throw error;
  }
};

// ─── Universal Requests ───────────────────────────────────────────────────────

export const getUniversalRequests = async (NTID) => {
  const url = `/api/v1/snow/universal-requests/${NTID}`;

  try {
    const response = await axiosInstance.get(url);
    const responseBody = response.data;
    const tickets = responseBody.data;

    if (responseBody.isSuccessful && Array.isArray(tickets)) {
      return tickets;
    } else {
      console.error('Universal Requests API: unexpected format:', responseBody);
      return [];
    }
  } catch (error) {
    console.error('Error fetching universal requests:', error);
    return [];
  }
};

export const getOthersUniversalRequests = async (NTID) => {
  const url = `/api/v1/snow/universal-requests/forOthers/${NTID}`;

  try {
    const response = await axiosInstance.get(url);
    const responseBody = response.data;
    const tickets = responseBody.data;

    if (responseBody.isSuccessful && Array.isArray(tickets)) {
      return tickets;
    } else {
      console.error('Universal Requests (others) API: unexpected format:', responseBody);
      return [];
    }
  } catch (error) {
    console.error('Error fetching universal requests for others:', error);
    return [];
  }
};

export const getUniversalRequestDetails = async (requestNumber) => {
  const url = `/api/v1/snow/universal-requests/details/${requestNumber}`;

  try {
    const response = await axiosInstance.get(url);
    if (response.status === 200) {
      if (response.data.isSuccessful) {
        return response.data;
      } else {
        console.error('Universal Request details error:', response.data.message);
        return [];
      }
    } else {
      console.error('Universal Request details status:', response.status);
      return [];
    }
  } catch (error) {
    console.error('Error fetching universal request details:', error);
    return [];
  }
};
